// Canonical list of WAWeb message types that carry downloadable media.
// Single source of truth — previously duplicated in team-inbox-helpers,
// message-retrieval-operations and chat-models with drifting contents.
export const WA_MEDIA_MESSAGE_TYPES: ReadonlySet<string> = new Set([
    'image',
    'video',
    'audio',
    'ptt',
    'document',
    'sticker',
    'gif',
    'ptv',
]);
